import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserById } from "./ManagerNotesslice";
import axios from "../../axios";
import { Card, Typography, Box } from "@material-ui/core";
import Chip from "@mui/material/Chip";
import PropTypes from "prop-types";

function ManagerNotes({ issueIdrow ,data}) {
  const dispatch = useDispatch();
  const { projectCode } = useSelector((state) => state.user);
  // const { data } = useSelector((state) => state.note);
  const [isFetched, setIsFetched] = useState(false); // Track if data is fetched



  // useEffect(() => {
  //   const fetchData = async () => {
  //     const clientId = JSON.parse(localStorage.getItem("clientid"));
  //     const userdata = {
  //       clientId: clientId,
  //       projectCode: projectCode,
  //       env: "DEV,UAT",
  //     };

  //     try {
  //       await axios.get(
  //         `agilesaas_devozy_project_mapping?AgileProjId=eq.${projectCode}&select=DevozyProjectDetails`
  //       );
        
  //       // Dispatch Redux action to fetch user data
  //       await dispatch(fetchUserById(userdata));
  //     } catch (err) {
  //       console.log("Error fetching data:", err);
  //     } finally {
  //       setIsFetched(true); // Set as fetched to prevent re-fetching
  //     }
  //   };

  //   if (!isFetched) fetchData();
  // }, [dispatch, projectCode, isFetched]);

  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  function getLatestUpdate(issueId, data) {

    
    if (!data) return null;

    const allUpdates = [];
    data.forEach((yearArray) => {
      if (Array.isArray(yearArray) && yearArray.length > 1) {
        const [, updates] = yearArray;
        if (Array.isArray(updates)) {
          updates
            .filter((update) => update.IssueId === issueId)
            .forEach((update) => allUpdates.push(update));
        }
      }
    });
    allUpdates.sort((a, b) => new Date(b.UpdatedDate) - new Date(a.UpdatedDate));
    return allUpdates.length > 0 ? allUpdates[0] : null;
  }

  const latestUpdate = useMemo(
    () => (data ? getLatestUpdate(issueIdrow, data) : null),
    [issueIdrow, data]
  );

  if (!latestUpdate) {
    return <Typography variant="body2">No updates available for this Issue ID.</Typography>;
  }

  return (
    <Card
    className="m-2 p-3"
    style={{
      borderRadius: "12px",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#ffffff",
    }}
  >
    <Box display="flex" flexDirection="column" alignItems="flex-start" gap="16px">
      <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#333" }}>
        Progress Update
      </Typography>

      <Box display="flex" alignItems="center" gap="10px">
        <Typography
          variant="body2"
          style={{
            whiteSpace: "pre-line",
            flex: 1,
            color: "#555",
          }}
        >
          {latestUpdate.Notes
            ? stripHtmlTags(
                latestUpdate.Notes.replace(/data:image\/[a-zA-Z]+;base64,[^\s"]+/g, "")
              )
            : "No recent notes available."}
        </Typography>
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
        <Typography variant="body2" style={{ color: "#888", fontSize: "14px",fontWeight:500 }}>
          {latestUpdate.PercentageProgressed
            ? `Percentage increased by ${latestUpdate.PercentageProgressed}% over the last ${latestUpdate.EffortRemaining} days.`
            : ""}
        </Typography>
        <Chip
          label={latestUpdate.StageCode}
          style={{
            backgroundColor: "#FFEBE0",
            color: "#FF7A00",
            fontWeight: "bold",
            fontSize: "12px",
            padding: "5px 10px",
            borderRadius: "6px",
          }}
        />
      </Box>
    </Box>
  </Card>
  );
}

export default ManagerNotes;
